var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5600a",
    opacity: 0.3,
    d: "M9.756,4.414,2.8,16.926a.833.833,0,0,0,.728,1.238h14.6a.833.833,0,0,0,.711-1.268L11.2,4.384a.833.833,0,0,0-1.439.03Z",
    transform: "translate(-0.45 -0.664)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f5600a",
    width: 1.667,
    height: 5.833,
    rx: 0.833,
    transform: "translate(9.167 7.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f5600a",
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(9.167 14.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0ac149a1a8cfb4d043897769ae8719a6.svg";
export { ForwardRef as ReactComponent };